var map = {
	"./product-icon1.png": "2723",
	"./product-icon2.png": "3bb6",
	"./product-icon3.png": "f960",
	"./product-icon4.png": "f576",
	"./product-icon5.png": "2235",
	"./product-icon6.png": "5083",
	"./product-icon7.png": "cdc7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b4e7";